import React, { useState } from "react";
import notrip from "../../../../assets/img/dashboard/notrip.svg";
import Button from "../../../shared/Button";
import RecentCard from "./RecentCard";
const MyConuterRecents = ({ dahsboardInfo }) => {
  const [tab, setTab] = useState("registered"); //saved //reserved //registered

  return (
    <div>
      <div className="flex gap-[36px] MyConuterRecents--header-tabbutton items-center  my-[80px]">
        <h5>آخرین ها :</h5>

        {/* <button
          className={`MyConuterRecents--button ${tab === "saved"
            ? "button__white"
            : ""}`}
          onClick={() => setTab("saved")}
        >
          اقامتگاه های ذخیره شده
        </button> */}
        <button
          className={`MyConuterRecents--button ${tab === "reserved"
            ? "button__white"
            : ""}`}
          onClick={() => setTab("reserved")}
        >
          سفرر های رزرو شده
        </button>
        <button
          className={`MyConuterRecents--button ${tab === "registered"
            ? "button__white"
            : ""}`}
          onClick={() => setTab("registered")}
        >
          اقامتگاه های ثبت شده
        </button>
      </div>

      {tab === "saved"
        ? <div> </div>
        : tab === "reserved"
          ? <div className="center-column notrip">
              <img src={notrip} />
              <h4>شما سفر رزرو شده ای ندارید</h4>
              <Button varient="primary">رزرو سفر جدید</Button>
            </div>
          : dahsboardInfo.user_residences.length === 0
            ? <div className="center-column notrip">
                <img src={notrip} />
                <h4>شما اقامتگاه ثبت شده ای ندارید</h4>
                <Button varient="primary">رزرو سفر جدید</Button>
              </div>
            : dahsboardInfo.user_residences.map(i =>
                <RecentCard reserved={false} info={i} />
              )}
    </div>
  );
};

export default MyConuterRecents;
